<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import EmployeeAPI from "../../../services/employee/employeeAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import BranchOfficeAPI from "../../../services/branch_offices/branch_officesAPI";
import CompanyAPI from "../../../services/company/companyAPI";
import CompanySSOAPI from "../../../services/sso/company/companySSO.API";
import ARLAPI from "../../../services/arl/arlAPI";
import EPSAPI from "../../../services/eps/epsAPI";
import AFPAPI from "../../../services/afp/afpAPI";
import IDTypeAPI from "../../../services/employee/idTypeAPI";
import municipalityAPI from "@/services/employee/municipalityAPI";
import departmentAPI from "@/services/employee/departmentAPI";
import Swal from "sweetalert2";
import { required, email, maxLength } from "vuelidate/lib/validators";
import { sendNotification } from "@/utils/helpers/notification";
import { getDate } from "@/utils/helpers/format";
import { number } from "@coders-tm/vue-number-format";
import DontExist from "@/components/company/components/DontExist"

/**
 * Form elements component
 */
export default {
  page: {
    title: "Editar colaborador",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    number,
    DontExist,
  },
  data() {
    return {
      title: "Gestion de empresa",
      items: [
        {
          text: "Listado de empresas",
          href: "/forms/listado-empresa",
        },
        {
          text: "Gestión empresa",
          href: `/forms/editar-empresa/${this.$store.getters["company/getCompany"].uuid}`
        },
        {
          text: "Editar empleado",
          active: true,
        },
      ],
      checked: true,
      checked2: false,
      status: "accepted",
      status2: "not_accepted",
      selected: "A",

      branchOffices: [],

      number: {
        decimal: ",",
        separator: ".",
        precision: 2,
        masked: false,
      },

      employeeData: {
        full_name: null,
        identification_number: null,
        gender: null,
        scholarship: null,
        marital_status: null,
        birthday: null,
        job_method: null,
        contract_start_date: null,
        contract_end_date: null,
        contribution_base_income: null,
        phone_1: null,
        phone_2: null,
        neighborhood: null,
        address: null,
        neighborhood_type: null,
        personal_email: null,
        corporate_email: null,
        arl_certificate: null,
        risk_class: null,
        is_active: 1,
        op_admin: "operative",
        identification_type_id: null,
        branch_office_id: null,
        contract_type_id: null,
        municipality_id: null,
        companies_id: null,
        afp_id: 1,
        eps_id: 1,
        rol_id: 5,
        implementation_status: 0,
        position: null,
        person_with_life: null,
        stratum_socioeconomic: null,
        colorcast: null,
        workshift: null,
        blood_group: null,
        emergency_contact_name: null,
        emergency_contact_relationship: null,
        emergency_contact_phone: null,
        emergency_contact_municipality_id: null,
      },

      allMunicipalities: [],
      bloodGroups: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
      emergencyMunicipalitySearch: "",
      emergencyMunicipalityOpen: false,

      arl: "",
      file: null,
      companyAPI: null,

      afp: [],
      eps: [],
      idTypes: [],

      municipality: [],
      department: [],
      department_id: null,
      anos: null,

      submitted: false, // validation

      loading1: true,
      loading2: true,
      loading3: true,

      companyData: this.$store.getters["company/getCompany"] || null,
      company: this.$store.getters["company/getCompany"] || null,
      company_id: this.$store.getters["company/getCompany"].id,
    };
  },
  validations: {
    employeeData: {
      full_name: {
        required,
        maxLength: maxLength(60),
      },
      identification_number: {
        required,
      },
      gender: {
        required,
      },
      colorcast: {
        required,
      },

      stratum_socioeconomic: {
        required,
      },
      person_with_life: {
        required,
      },
      workshift: {
        required,
      },

      scholarship: {
        required,
      },
      marital_status: {
        required,
      },
      birthday: {
        required,
      },
      job_method: {
        required,
      },
      contract_start_date: {
        required,
      },
      contribution_base_income: {
        required,
      },
      phone_1: {
        required,
        maxLength: maxLength(15),
      },

      neighborhood: {
        required,
        maxLength: maxLength(45),
      },
      address: {
        required,
        maxLength: maxLength(45),
      },
      neighborhood_type: {
        required,
      },
      personal_email: {
        required,
        email,
        maxLength: maxLength(80),
      },

      corporate_email: {
        required,
        email,
        maxLength: maxLength(80),
      },

      arl_certificate: {
        required,
      },

      risk_class: {
        required,
      },
      is_active: {
        required,
      },
      op_admin: {
        required,
      },
      identification_type_id: {
        required,
      },
      contract_type_id: {
        required,
      },
      municipality_id: {
        required,
      },
      afp_id: {
        required,
      },
      eps_id: {
        required,
      },
      position: {
        required,
        maxLength: maxLength(30),
      },
    },
  },
  computed: {
    filteredEmergencyMunicipalities() {
      const q = (this.emergencyMunicipalitySearch || "").toLowerCase().trim();
      const list = this.allMunicipalities || [];
      if (!q) return list;
      return list.filter((m) => (m.name || "").toLowerCase().includes(q));
    },
  },
  watch: {
    allMunicipalities() {
      this.syncEmergencyMunicipalityLabel();
    },
    "employeeData.emergency_contact_municipality_id"() {
      this.syncEmergencyMunicipalityLabel();
    },
  },
  methods: {
    CalcularEdad(birthday) {
      let actual = new Date();
      let nacimiento = new Date(birthday);
      this.anos = actual.getFullYear() - nacimiento.getFullYear();

      // Verifica si aún no ha pasado el cumpleaños este año
      if (
        actual.getMonth() < nacimiento.getMonth() ||
        (actual.getMonth() === nacimiento.getMonth() && actual.getDate() < nacimiento.getDate())
      ) {
        this.anos--;
      }
      return this.anos;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        company.id_diseno_sso,
        messageID,
        itemID
      );
    },

    getMunicipality() {
      municipalityAPI
        .getAllMunicipality()
        .then((response) => {
          this.municipality = response.List.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAllMunicipalitiesForEmergency() {
      municipalityAPI
        .getAllUnpaginated()
        .then((response) => {
          this.allMunicipalities = response.List || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onEmergencyMunicipalitySearch(e) {
      this.emergencyMunicipalitySearch = e.target.value;
      this.emergencyMunicipalityOpen = true;
      if (!e.target.value) {
        this.employeeData.emergency_contact_municipality_id = null;
      }
    },

    selectEmergencyMunicipality(item) {
      this.employeeData.emergency_contact_municipality_id = item.id;
      this.emergencyMunicipalitySearch = item.name;
      this.emergencyMunicipalityOpen = false;
    },

    closeEmergencyMunicipalityDropdown() {
      setTimeout(() => {
        this.emergencyMunicipalityOpen = false;
      }, 150);
    },

    syncEmergencyMunicipalityLabel() {
      const id = this.employeeData.emergency_contact_municipality_id;
      const list = this.allMunicipalities || [];
      if (!id || list.length === 0) return;
      const m = list.find((x) => x.id === id);
      if (m && this.emergencyMunicipalitySearch !== m.name) {
        this.emergencyMunicipalitySearch = m.name;
      }
    },

    getMunByEmployee(id) {
      municipalityAPI
        .get(id)
        .then((response) => {
          const data = response.municipality;
          this.department_id = data.department_id;
          this.getByMunByDeparment();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getByMunByDeparment() {
      municipalityAPI
        .getByDepartment(this.department_id)
        .then((response) => {
          this.municipality = response.List;
          this.loading3 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getDepartment() {
      departmentAPI
        .getAllDepartment()
        .then((response) => {
          this.department = response.List;
          this.loading2 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getData() {
      try {
        const types = await IDTypeAPI.getIDTypes();
        this.idTypes = types.Identification_type || [];
        const eps = await EPSAPI.getAllEPS();
        if (eps) { this.eps = eps; }

        const afp = await AFPAPI.getAllAFP();
        if (afp) { this.afp = afp.Afp || []; }

        const employee = await EmployeeAPI.getEmployee(this.$route.params.id);
        this.employeeData = employee;
        this.employeeData.birthday = getDate(employee.birthday);
        this.employeeData.contract_start_date = getDate(employee.contract_start_date);
        this.employeeData.contract_end_date = getDate(employee.contract_end_date);
        this.CalcularEdad(employee.birthday);
        this.getMunByEmployee(employee.municipality_id);
        const company = await CompanyAPI.getCompany(employee.companies_id);
        this.companyAPI = company;
        const sso = await CompanySSOAPI.getCompany(this.companyAPI.uuid);
        this.company = sso;

        const { arl } = await ARLAPI.getAllARLs();

        if (arl) { this.arl = arl.find((item) => item.id === this.companyAPI.arl_id).name || null; }

        const branchOffice = await BranchOfficeAPI.getNotPaginate(this.companyAPI.id);
        this.branchOffices = branchOffice.branch;
        this.loading1 = false;
      } catch (error) {
        console.log(error);
      }
    },

    changeDate() {
      if (this.employeeData.is_active === 1) {
        this.employeeData.contract_end_date = null;
      }
    },

    /**
     * Get file name with format.
     * @param {String} file Is the name the file.
     * @return {String} The new format the file name.
     */
    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.employeeData.arl_certificate)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/Registro_Empleados/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.company.nit}/Registro_Empleados/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.employeeData.arl_certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      try {
        this.submitted = true
        this.loading1 = true
        let response = await this.uploadDocument();
        if (response) {
          EmployeeAPI.updateEmployee(this.employeeData)
            .then((res) => {
              const status = Number(res?._status || 0);
              if (status === 422) {
                const errors = res?.errors || {};
                const messages = Object.values(errors).flat().slice(0, 8);
                Swal.fire({
                  title: "Datos inválidos",
                  html: messages.length
                    ? "<ul style='text-align: left; padding-left: 20px;'>" +
                      messages.map((m) => `<li>${m}</li>`).join("") +
                      "</ul>"
                    : (res?.message || "Revise los campos del formulario."),
                  icon: "warning",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                this.loading1 = false;
                this.submitted = false;
                return;
              }
              if (res.result === "Updated") {
                const user = JSON.parse(localStorage.getItem('user'))
                const dataScores = {
                  access_token: user.token,
                  companies_id: this.company_id
                }
                newScoresAPI.classificationCompanie(dataScores).then((response) => {
                  this.loading1 = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha actualizado con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                  }, 2000)
                  this.$router.go(-1)
                }).catch((error) => {
                  console.log(error);
                  Swal.fire({
                    title: "Error!",
                    text: "¡No se ha podido actualizar!",
                    type: "error",
                    icon: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                });
              }
            }).catch((error) => {
              console.log(error);
            });
        } else {
          this.loading1 = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido actualizar!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload()
          }, 2000)
        }
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      window.location.href = `/forms/editar-empresa/${this.$store.getters["company/getCompany"].uuid}`;
    },
  },

  mounted() {
    this.getData();
    this.getDepartment();
    this.getByMunByDeparment();
    this.getAllMunicipalitiesForEmergency();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div v-if="!loading1 && !loading2 && !loading3">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <h4 class="header-title">Información del colaborador</h4>
                </div>

                <div class="col-6 text-right">
                  <div class="btn btn-secondary m-l-5 ml-1" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                </div>
              </div>

              <div style="padding-top: 20px" class="row">
                <div class="col-12">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="p-2">
                          <form class="form-horizontal form-group" role="form" @submit.prevent="update">
                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Nombre completo" label-for="name">
                                  <b-form-input required type="text" id="name" maxlength="60"
                                    v-model="employeeData.full_name">
                                  </b-form-input>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Género" label-for="gender">
                                  <select id="gender" class="form-control" v-model="employeeData.gender" required>
                                    <option value="woman">Femenino</option>
                                    <option value="man">Masculino</option>
                                    <option value="other">Otros</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Tipo de identificación" label-for="id_type">
                                  <select id="id_type" class="form-control"
                                    v-model="employeeData.identification_type_id" required>
                                    <option v-for="item in idTypes" :value="item.id" :key="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Número de identificación"
                                  label-for="id_number">
                                  <b-form-input maxlength="20" type="text" id="id_number" inputmode="numeric"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                                    v-model="employeeData.identification_number" required>
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Escolaridad" label-for="scholarship">
                                  <select id="scholarship" class="form-control" v-model="employeeData.scholarship"
                                    required>
                                    <option value="elementary">Primaria</option>
                                    <option value="high_school">
                                      Secundaria
                                    </option>
                                    <option value="technician">
                                      Técnica y Tecnología
                                    </option>
                                    <option value="college">
                                      Universitaria
                                    </option>
                                    <option value="graduate_school">
                                      Postgrado
                                    </option>
                                  </select>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Estado civil" label-for="marital">
                                  <select id="marital" class="form-control" v-model="employeeData.marital_status"
                                    required>
                                    <option value="single">Soltero(a)</option>
                                    <option value="married">Casado(a)</option>
                                    <option value="unmarried">
                                      Unión libre
                                    </option>
                                    <option value="widower">Viudo(a)</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12 pb-0 m-0">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Fecha de nacimiento" label-for="birthday">
                                  <b-form-input type="date" id="birthday" v-on:change="
                                    CalcularEdad(employeeData.birthday)" v-model="employeeData.birthday" required>
                                  </b-form-input>
                                  <p id="edad">
                                    <small>La edad del colaborador es:
                                      {{ this.anos }}
                                    </small>
                                  </p>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Tipo de contrato"
                                  label-for="contract_type_id">
                                  <select id="contract_type_id" class="form-control"
                                    v-model="employeeData.contract_type_id" required>
                                    <option :value="1">Planta</option>
                                    <option :value="3">Contratista</option>
                                    <option :value="2">Aprendiz</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Personas con las que convive"
                                  label-for="gender">
                                  <select id="gender" class="form-control" v-model="employeeData.person_with_life"
                                    required>
                                    <option value="0">0</option>
                                    <option value="1 o 2">1 o 2</option>
                                    <option value="3 o más">3 o más</option>
                                  </select>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Estrato socioeconómico" label-for="gender">
                                  <select id="gender" class="form-control" v-model="employeeData.stratum_socioeconomic"
                                    required>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Raza" label-for="gender">
                                  <select id="gender" class="form-control" v-model="employeeData.colorcast" required>
                                    <option value="Blanco">Blanco</option>
                                    <option value="Mestizo">Mestizo</option>
                                    <option value="Afrodescendiente">Afrodescendiente</option>
                                    <option value="Indígena">Indígena</option>
                                  </select>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Turno de trabajo" label-for="gender">
                                  <select id="gender" class="form-control" v-model="employeeData.workshift" required>
                                    <option value="Diurno">Diurno</option>
                                    <option value="Nocturno">Nocturno</option>
                                    <option value="Mixto">Mixto</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Tipo de sangre" label-for="blood_group">
                                  <select id="blood_group" class="form-control" v-model="employeeData.blood_group">
                                    <option :value="null">-- Seleccione --</option>
                                    <option v-for="bg in bloodGroups" :key="bg" :value="bg">{{ bg }}</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12 pb-0 m-0">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Fecha de inicio"
                                  label-for="contract_start_date">
                                  <b-form-input type="date" id="contract_start_date"
                                    v-model="employeeData.contract_start_date" required>
                                  </b-form-input>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Fecha fin" label-for="contract_end_date">
                                  <b-form-input :required="employeeData.is_active !== 1" type="date"
                                    id="contract_end_date" :disabled="employeeData.is_active === 1"
                                    v-model="employeeData.contract_end_date" required>
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Modalidad de prestación de servicio"
                                  label-for="job_method">
                                  <select id="job_method" class="form-control" v-model="employeeData.job_method"
                                    required>
                                    <option value="office">Presencial</option>
                                    <option value="hibrid">Teletrabajo</option>
                                    <option value="remote">
                                      Trabajo remoto
                                    </option>
                                  </select>
                                </b-form-group>

                                <b-form inline style="padding-left: 30px;padding-top: 10px;padding-bottom: 10px;">
                                  <b-form-radio v-model="employeeData.op_admin" value="operative"
                                    class="mb-2 mr-sm-2 mb-sm-0">Operativo
                                  </b-form-radio>
                                  <b-form-radio v-model="employeeData.op_admin" value="administrative"
                                    class="mb-2 mr-sm-2 mb-sm-0">Administrativo
                                  </b-form-radio>
                                </b-form>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Empresa" label-for="company_name">
                                  <b-form-input required type="text" id="company_name" v-model="company.social_reason"
                                    :disabled="true"></b-form-input>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Centro de trabajo asignado"
                                  label-for="branch_office_id">
                                  <select id="branch_ofice_id" class="form-control"
                                    v-model="employeeData.branch_office_id">
                                    <option v-for="item in branchOffices" :value="item.id" :key="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Ingreso base de cotización"
                                  label-for="inputIncome">
                                  <input v-model="employeeData.contribution_base_income"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" maxlength="15"
                                    type="text" class="form-control" required />
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Cargo" label-for="position">
                                  <b-form-input type="text" id="position" maxlength="30" v-model="employeeData.position"
                                    required>
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Email personal" label-for="personal_email">
                                  <b-form-input type="text" maxlength="80" id="personal_email"
                                    v-model="employeeData.personal_email" required>
                                  </b-form-input>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Email corporativo "
                                  label-for="corporate_email">
                                  <b-form-input type="text" maxlength="80" id="corporate_email"
                                    v-model="employeeData.corporate_email" required>
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Clase de riesgo" label-for="risk_class">
                                  <select id="risk_class" class="form-control" v-model="employeeData.risk_class"
                                    required>
                                    <option value="group_1">Clase I</option>
                                    <option value="group_2">Clase II</option>
                                    <option value="group_3">Clase III</option>
                                    <option value="group_4">Clase IV</option>
                                    <option value="group_5">Clase V</option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Estado" label-for="is_active">
                                  <select id="is_active" class="form-control" v-model="employeeData.is_active" required
                                    v-on:change="changeDate">
                                    <option :value="1">Activo</option>
                                    <option :value="0">Inactivo</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Teléfono 1" label-for="inputPhone">
                                  <b-form-input maxlength="15" type="text" id="inputPhone"
                                    v-model="employeeData.phone_1"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" required>
                                  </b-form-input>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Teléfono 2" label-for="inputPhone">
                                  <b-form-input maxlength="15" type="text" id="inputPhone"
                                    v-model="employeeData.phone_2"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)">
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Departamento" label-for="department_id">
                                  <select id="department_id" class="form-control" v-model="department_id"
                                    @change="getByMunByDeparment()">
                                    <b-form-select-option v-for="item in department" :key="item.id" :value="item.id">
                                      {{ item.name }}
                                    </b-form-select-option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Ciudad" label-for="inputState">
                                  <select class="form-control" v-model="employeeData.municipality_id" required>
                                    <b-form-select-option v-for="item in municipality" :key="item.id" :value="item.id">
                                      {{ item.name }}
                                    </b-form-select-option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Barrio" label-for="inputNeighborhood">
                                  <b-form-input type="text" maxlength="45" id="inputNeighborhood"
                                    v-model="employeeData.neighborhood" required>
                                  </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Dirección" label-for="inputAddress">
                                  <b-form-input type="text" maxlength="45" id="inputAddress"
                                    v-model="employeeData.address" required>
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Zona" label-for="inputState">
                                  <select id="inputState" class="form-control" v-model="employeeData.neighborhood_type"
                                    required>
                                    <option value="urban">Urbana</option>
                                    <option value="rural">Rural</option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="EPS" label-for="eps_id">
                                  <select id="eps_id" class="form-control" v-model="employeeData.eps_id" required>
                                    <option v-for="item in eps" :value="item.id" :key="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="AFP" label-for="afp_id">
                                  <select id="afp_id" class="form-control" v-model="employeeData.afp_id" required>
                                    <option v-for="item in afp" :value="item.id" :key="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" :label="`ARL: ${arl || ''}`" label-for="file">
                                  <b-form-file type="file" id="file" ref="file" name="file" browse-text="Buscar" inline
                                    :placeholder="employeeData.arl_certificate
                                      ? getFile(employeeData.arl_certificate)
                                      : `Selecciona un archivo...`
                                      " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile"
                                    v-on:change="uploadFile"
                                    accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                                  </b-form-file>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12 mt-3">
                              <h5 class="header-title">Contacto de emergencia</h5>
                              <small class="text-muted">Todos los campos son opcionales.</small>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Nombre contacto de emergencia"
                                  label-for="emergency_contact_name">
                                  <b-form-input maxlength="100" type="text" id="emergency_contact_name"
                                    v-model="employeeData.emergency_contact_name">
                                  </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Parentesco"
                                  label-for="emergency_contact_relationship">
                                  <b-form-input maxlength="50" type="text" id="emergency_contact_relationship"
                                    v-model="employeeData.emergency_contact_relationship">
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Teléfono contacto de emergencia"
                                  label-for="emergency_contact_phone">
                                  <b-form-input maxlength="20"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" type="text"
                                    id="emergency_contact_phone" v-model="employeeData.emergency_contact_phone">
                                  </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Ciudad de residencia (contacto de emergencia)"
                                  label-for="emergency_contact_municipality_id">
                                  <div class="position-relative">
                                    <input id="emergency_contact_municipality_id" type="text" class="form-control"
                                      autocomplete="off" placeholder="Escribe para buscar ciudad..."
                                      :value="emergencyMunicipalitySearch" @input="onEmergencyMunicipalitySearch"
                                      @focus="emergencyMunicipalityOpen = true"
                                      @blur="closeEmergencyMunicipalityDropdown" />
                                    <ul v-if="emergencyMunicipalityOpen"
                                      class="list-group position-absolute w-100 shadow-sm"
                                      style="max-height: 220px; overflow-y: auto; z-index: 1050;">
                                      <li v-if="filteredEmergencyMunicipalities.length === 0"
                                        class="list-group-item text-muted">
                                        Sin resultados
                                      </li>
                                      <li v-for="item in filteredEmergencyMunicipalities" :key="item.id"
                                        class="list-group-item list-group-item-action"
                                        style="cursor: pointer;"
                                        @mousedown.prevent="selectEmergencyMunicipality(item)">
                                        {{ item.name }}
                                      </li>
                                    </ul>
                                  </div>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="form-group text-right m-b-0">
                              <button :disabled="submitted" type="submit" class="btn btn-primary">
                                Guardar
                              </button>
                              <button type="reset" class="btn btn-secondary m-l-5 ml-1" @click="goBack">
                                Cancelar
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end row -->
            </div>
          </div>
        </div>

        <div v-else-if="(!loading1 || !loading2 || !loading3) && !companyData.legal_representative">
          <DontExist text="se debe actualizar la información de la empresa para proceder." />
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- end row -->
  </Layout>
</template>
